export const countryCodes = {
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas (the)',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia (Plurinational State of)',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory (the)',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  KY: 'Cayman Islands (the)',
  CF: 'Central African Republic (the)',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands (the)',
  CO: 'Colombia',
  KM: 'Comoros (the)',
  CD: 'Congo (the Democratic Republic of the)',
  CG: 'Congo (the)',
  CK: 'Cook Islands (the)',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  CI: "Côte d'Ivoire",
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic (the)',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (the) [Malvinas]',
  FO: 'Faroe Islands (the)',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories (the)',
  GA: 'Gabon',
  GM: 'Gambia (the)',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (the)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran (Islamic Republic of)',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea (the Democratic People's Republic of)",
  KR: 'Korea (the Republic of)',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic (the)",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands (the)',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia (Federated States of)',
  MD: 'Moldova (the Republic of)',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands (the)',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger (the)',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands (the)',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine, State of',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines (the)',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  MK: 'Republic of North Macedonia',
  RO: 'Romania',
  RU: 'Russian Federation (the)',
  RW: 'Rwanda',
  RE: 'Réunion',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan (the)',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan (Province of China)',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands (the)',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates (the)',
  GB: 'United Kingdom of Great Britain and Northern Ireland (the)',
  UM: 'United States Minor Outlying Islands (the)',
  US: 'United States of America (the)',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela (Bolivarian Republic of)',
  VN: 'Viet Nam',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AX: 'Åland Islands',
}
export const deCountryCodes = {
  AC: 'Ascension',
  AD: 'Andorra',
  AE: 'Vereinigte Arabische Emirate',
  AF: 'Afghanistan',
  AG: 'Antigua und Barbuda',
  AI: 'Anguilla',
  AL: 'Albanien',
  AM: 'Armenien',
  AN: 'Niederländische Antillen',
  AO: 'Angola',
  AQ: 'Antarktis',
  AR: 'Argentinien',
  AS: 'Amerikanisch-Samoa',
  AT: 'Österreich',
  AU: 'Australien',
  AW: 'Aruba',
  AX: 'Alandinseln',
  AZ: 'Aserbaidschan',
  BA: 'Bosnien u. Herzegowina',
  BB: 'Barbados',
  BD: 'Bangladesch',
  BE: 'Belgien',
  BF: 'Burkina Faso',
  BG: 'Bulgarien',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'St. Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei Darussalam',
  BO: 'Bolivien',
  BQ: 'Britisches Antarktis-Territorium',
  BR: 'Brasilien',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BV: 'Bouvetinsel',
  BW: 'Botsuana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Kanada',
  CC: 'Kokosinseln',
  CD: 'Demokratische Republik Kongod',
  CF: 'Zentralafrikanische Republik',
  CG: 'Kongo-Brazzavilled',
  CH: 'Schweiz',
  CI: 'Elfenbeinküste',
  CK: 'Cookinseln',
  CL: 'Chile',
  CM: 'Kamerun',
  CN: 'China',
  CO: 'Kolumbien',
  CP: 'Clipperton',
  CR: 'Costa Rica',
  CS: 'Serbien und Montenegro',
  CT: 'Phoenixinseln',
  CU: 'Kuba',
  CV: 'Kap Verde',
  CX: 'Weihnachtsinsel',
  CY: 'Zypern',
  CZ: 'Tschechische Republik',
  DD: 'Ostdeutschland',
  DE: 'Deutschland',
  DG: 'Diego Garcia',
  DJ: 'Dschibuti',
  DK: 'Dänemark',
  DM: 'Dominica',
  DO: 'Dominikanische Republik',
  DZ: 'Algerien',
  EA: 'Ceuta und Melilla',
  EC: 'Ecuador',
  EE: 'Estland',
  EG: 'Ägypten',
  EH: 'Westsahara',
  ER: 'Eritrea',
  ES: 'Spanien',
  ET: 'Äthiopien',
  EU: 'EU',
  FI: 'Finnland',
  FJ: 'Fidschi',
  FK: 'Falklandinseln',
  FM: 'Mikronesien',
  FO: 'Färöer',
  FQ: 'Französische Süd- und Antarktisgebiete',
  FR: 'Frankreich',
  FX: 'Metropolitan-Frankreich',
  GA: 'Gabun',
  GB: 'Vereinigtes Königreich',
  GD: 'Grenada',
  GE: 'Georgien',
  GF: 'Französisch-Guayana',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Grönland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Äquatorialguinea',
  GR: 'Griechenland',
  GS: 'Südgeorgien und die Südlichen Sandwichinseln',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hongkong',
  HM: 'Heard- und McDonald-Inseln',
  HN: 'Honduras',
  HR: 'Kroatien',
  HT: 'Haiti',
  HU: 'Ungarn',
  IC: 'Kanarische Inseln',
  ID: 'Indonesien',
  IE: 'Irland',
  IL: 'Israel',
  IM: 'Isle of Man',
  IN: 'Indien',
  IO: 'Britisches Territorium im Indischen Ozean',
  IQ: 'Irak',
  IR: 'Iran',
  IS: 'Island',
  IT: 'Italien',
  JE: 'Jersey',
  JM: 'Jamaika',
  JO: 'Jordanien',
  JP: 'Japan',
  JT: 'Johnston-Atoll',
  KE: 'Kenia',
  KG: 'Kirgisistan',
  KH: 'Kambodscha',
  KI: 'Kiribati',
  KM: 'Komoren',
  KN: 'St. Kitts und Nevis',
  KP: 'Nordkorea',
  KR: 'Republik Korea',
  KW: 'Kuwait',
  KY: 'Kaimaninseln',
  KZ: 'Kasachstan',
  LA: 'Laos',
  LB: 'Libanon',
  LC: 'St. Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Litauen',
  LU: 'Luxemburg',
  LV: 'Lettland',
  LY: 'Libyen',
  MA: 'Marokko',
  MC: 'Monaco',
  MD: 'Republik Moldau',
  ME: 'Montenegro',
  MF: 'St. Martin',
  MG: 'Madagaskar',
  MH: 'Marshallinseln',
  MI: 'Midwayinseln',
  MK: 'Mazedonien',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolei',
  MO: 'Macaud',
  MP: 'Nördliche Marianen',
  MQ: 'Martinique',
  MR: 'Mauretanien',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Malediven',
  MW: 'Malawi',
  MX: 'Mexiko',
  MY: 'Malaysia',
  MZ: 'Mosambik',
  NA: 'Namibia',
  NC: 'Neukaledonien',
  NE: 'Niger',
  NF: 'Norfolkinsel',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Niederlande',
  NO: 'Norwegen',
  NP: 'Nepal',
  NQ: 'Königin-Maud-Land',
  NR: 'Nauru',
  NT: 'Neutrale Zone',
  NU: 'Niue',
  NZ: 'Neuseeland',
  OM: 'Oman',
  PA: 'Panama',
  PC: 'Treuhandgebiet Pazifische Inseln',
  PE: 'Peru',
  PF: 'Französisch-Polynesien',
  PG: 'Papua-Neuguinea',
  PH: 'Philippinen',
  PK: 'Pakistan',
  PL: 'Polen',
  PM: 'St. Pierre und Miquelon',
  PN: 'Pitcairn',
  PR: 'Puerto Rico',
  PS: 'Palästinensische Autonomiegebiete',
  PT: 'Portugal',
  PU: 'U.S. Miscellaneous Pacific Islands',
  PW: 'Palau',
  PY: 'Paraguay',
  PZ: 'Panamakanalzone',
  QA: 'Katar',
  QO: 'Äußeres Ozeanien',
  RE: 'Réunion',
  RO: 'Rumänien',
  RS: 'Serbien',
  RU: 'Russische Föderation',
  RW: 'Ruanda',
  SA: 'Saudi-Arabien',
  SB: 'Salomonen',
  SC: 'Seychellen',
  SD: 'Sudan',
  SE: 'Schweden',
  SG: 'Singapur',
  SH: 'St. Helena',
  SI: 'Slowenien',
  SJ: 'Svalbard und Jan Mayen',
  SK: 'Slowakei',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'São Tomé und Príncipe',
  SU: 'Sowjetunion',
  SV: 'El Salvador',
  SY: 'Syrien',
  SZ: 'Swasiland',
  TA: 'Tristan da Cunha',
  TC: 'Turks- und Caicosinseln',
  TD: 'Tschad',
  TF: 'Französische Süd- und Antarktisgebiete',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tadschikistan',
  TK: 'Tokelau',
  TL: 'Osttimor',
  TM: 'Turkmenistan',
  TN: 'Tunesien',
  TO: 'Tonga',
  TR: 'Türkei',
  TT: 'Trinidad und Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'Tansania',
  UA: 'Ukraine',
  UG: 'Uganda',
  UM: 'United States Minor Outlying Islands',
  US: 'Vereinigte Staaten',
  UY: 'Uruguay',
  UZ: 'Usbekistan',
  VA: 'Vatikanstadt',
  VC: 'St. Vincent und die Grenadinen',
  VD: 'Nordvietnam',
  VE: 'Venezuela',
  VG: 'Britische Jungferninseln',
  VI: 'Amerikanische Jungferninseln',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WF: 'Wallis und Futuna',
  WK: 'Wake',
  WS: 'Samoa',
  YD: 'Volksdemokratische Republik Jemen',
  YE: 'Jemen',
  YT: 'Mayotte',
  ZA: 'Südafrika',
  ZM: 'Sambia',
  ZW: 'Simbabwe',
  ZZ: 'Unbekannte oder ungültige Region',
}
